import {ICardAreaUIConfig, PredefinedCardViewConfig, WorkspaceConfig} from '@stores/config'

export * from './detailsView'
export * from './workspace'
export * from './mutations'
export * from './DeploymentConfig'

import {DetailsFieldType} from '@stores/config/deployment/detailsView/ui'

export interface IDocMapping {
  primaryIndex: string
  docRefs?: Array<IMutationDocRef>
}

export type IMutationDocRef = {
  index: string,
  nodePrefix: string
}

export type FieldType = 'String' | 'Boolean' | 'Float' | 'Tag' | 'TagList' | 'DateTime' | 'Int' | 'Enum' | 'EnumList' | 'RefList' | 'Ref' | 'Double' | 'LookupItem' | 'LookupItemList' |DetailsFieldType

export interface IDataMapConfig {
  cardTitle?: string
  images?: string
  title?: string
  subtitle1?: string
  subtitle2?: string
  subtitle3?: string
  active?: string

  sections?: Array<{fields: Array<{field: string, style?: 'h1' | 'h2' | string}>}>

  secondary?: ICardAreaUIConfig

  /*
  Override for title when in modals  YFTS-10047
   */
  modalTitle?: string
}

/**
 * Examples include vlp-merch-product-version, vlp-colorway, vlp-material, etc
 *
 */
export type WorkspaceElasticSearchIndex = string

/**
 * Buttons added to the toolbar that can turn on and off entire sets of fields
 *
 * Style might turn off mpv.styles.*
 */
export interface ISectionConfig {
  label?: string,
  id: string
  path?: string
  field?: string,
  type?: 'arrXref'|'xref'| 'other'
  esIndex?: WorkspaceElasticSearchIndex
  workspace?: WorkspaceConfig

  visible?: boolean

  /**
   * Extra view option fields, originally for YFTS-6027
   */
  viewOptions?: ISectionViewOptionConfig
  sort?: {
    /** Can the catalog item cards be sorted by this field? */
    catalogItem?: boolean
  }
  customSequence?: Array<string>

  /**
   * Added by sanitizer to track # of FKs to reach the section from the main workspace
   */
  depth?: number
}

export interface ISupportedContexts {
  imageOperation?: boolean
}

export interface ISectionViewOptionConfig {
  /**
   * Query to create dynamic view options
   * Originally for YFTS-6027
   */
  field: string

  /**
   * YFTS-6860 Predefined default values for checking secondaries
   */
  cardViews?: Array<PredefinedCardViewConfig>

  nestedView?: boolean
  /**
   * YFTS-7335 - Move Secondary attributes into the secondary tab
   */
  hideOnViewOptionsTab?: boolean
}

export type CatalogCardImagesView = 'first' | 'stack' | 'carousel' | 'grid'

export interface CatalogImageSourceConfig {
  id?: string
  fields?: string[]
  field?: string
  label?: string
  background?: string
  index?: string
  type?: string
  workspace?: WorkspaceConfig
}

export interface IDragType {
  name: string,
  field: string,
  index: WorkspaceElasticSearchIndex,
  source: string[],
  path: string[],
  entityType: 'array' | 'object',
  queryField?: string
}

export interface IHierarchyIcon {
  name: 'APPAREL' | 'FOOTWEAR',
  level: 1 | 2 | 3 | 4,
  path: string
}



// WEBPACK FOOTER //
// ./src/stores/config/deployment/index.ts